import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

const INITIAL_POSITION = '-70px';
const ANIMATE_TIMING = '0.3s linear';

@Component({
  animations: [
    trigger('upDownAnimation', [
      transition(':enter', [
        style({ bottom: INITIAL_POSITION }),
        animate(ANIMATE_TIMING, style({ bottom: 0 })),
      ]),
      transition(':leave', [animate(ANIMATE_TIMING, style({ bottom: INITIAL_POSITION }))]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective],
  selector: 'aux-save-changes',
  styleUrls: ['save-changes.component.scss'],
  templateUrl: './save-changes.component.html',
})
export class SaveChangesComponent implements OnDestroy, OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() cancel = new EventEmitter();
  @Input() onSaveChanges!: VoidFunction;
  @Input() saveChangesDisabled = false;
  @Input() saveChangesTooltip = '';
  @Input() showDiscardChangesBtn = false;

  ngOnInit(): void {
    this.moveJiraWidget('90px');
  }

  ngOnDestroy(): void {
    this.moveJiraWidget('0');
  }

  moveJiraWidget(offset: string) {
    const widget = document.getElementById('jsd-widget');

    if (widget) {
      widget.style.bottom = offset;
    }
  }

  onDiscardChanges(): void {
    this.cancel.emit();
  }
}
